import useDevice from "@/hooks/useDevice";
import { FC, ReactNode } from "react";

interface Props {
  title: string;
  description?: string;
  backgroundImageUrl: string;
  linkElm?: JSX.Element;
  btns?: ReactNode;
}

const CategoryHeader: FC<Props> = ({
  title,
  description,
  backgroundImageUrl,
  linkElm,
  btns,
}): JSX.Element => {
  const { isSp } = useDevice();

  return (
    <header className="flex flex-col laptop:flex-row-reverse laptop:gap-32 laptop:space-x-reverse">
      <div className="flex flex-1 flex-col space-y-8">
        <div
          className="bg-cover bg-center bg-no-repeat aspect-video"
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
            height: isSp ? 160 : "auto",
          }}
        />
        {linkElm && <div className="small:px-8 text-right">{linkElm}</div>}
      </div>
      <div className="flex flex-col space-y-24 flex-1 small:p-12">
        <div className="space-y-12">
          <h1 className="text-2xl laptop:text-4xl font-bold">{title}</h1>
          {description && (
            <p className="text-sm leading-loose">{description}</p>
          )}
        </div>

        {btns && (
          <div className="flex flex-col laptop:flex-row laptop:items-center gap-8">
            {btns}
          </div>
        )}
      </div>
    </header>
  );
};

export default CategoryHeader;
